import type { LineFulfillment, OrderStatus } from '@fitting-room/contracts'
import { FULFILLMENT_LABEL, ORDER_STATUS_LABEL } from '../../../lib/orders'

/**
 * An order's status, after tperent's `OrderStatusBadge`: the word, colored
 * from the attribute so the color can never say something the word does not.
 */
export function OrderStatusBadge({ status }: { readonly status: OrderStatus }) {
  return (
    <span className="st-badge st-order-status" data-status={status}>
      {ORDER_STATUS_LABEL[status]}
    </span>
  )
}

/** Where a line is on its way to the customer. Nothing to show for a line with no fulfillment. */
export function FulfillmentBadge({ fulfillment }: { readonly fulfillment: LineFulfillment }) {
  if (fulfillment === 'none') return null
  return (
    <span className="st-badge st-fulfillment" data-fulfillment={fulfillment}>
      {FULFILLMENT_LABEL[fulfillment]}
    </span>
  )
}
